<template>
  <div class="teamlist">
    <!-- <HeaderTop></HeaderTop> -->
    <!-- <Header :page="0"></Header> -->
    <el-breadcrumb separator="/" class="bread-crumb main">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>专家团队</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="teamlist-box  main">
      <div class="board  flex-align" v-for="(item, index) in expertteam" :key="index">
        <div class="left pointer">
          <img :src="item.image" alt="" />
        </div>
        <div class="right pointer">
          <p class="name">{{ item.name }}</p>
          <p class="instruction">{{ item.instruction }}</p>
        </div>
      </div>
    </div>
    <div class="page-box">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        layout="prev, pager, next"
        :total="total">
      </el-pagination>
    </div>

    <footer-view></footer-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
      expertteam: [],
      total:null,
      pageNum:1,
      pageSize:10,
    };
  },
  computed: {},
  methods: {
      handleCurrentChange(val) {
        this.pageNum = val
        this.getTeaList()
      },
    // 专家团队
    async getTeaList() {
      let params = {
        pageNum:this.pageNum,
        pageSize:this.pageSize,
      };
      let resData = await Api.Home.getTeaList(params);
        this.total = resData.total;
        this.expertteam = resData.rows;
    },
  },
  mounted() {
    this.getTeaList();
  },
  beforeDestroy() {},
};
</script>

<style lang="less" scoped>
@import "./less/news_common.less";
@white: #fff;
.teamlist {
  background-color: @white;

  .main {
    width: 1200px;
    margin: 0 auto;
  }
  .teamlist-box {

    .board {
      border-bottom: 1px solid #F0EEEE;
      padding-bottom: 30px;
      margin-bottom:30px;

      .left {
        // border: 1px solid #e9e9e9;
        border-radius: 5px;
        padding: 8px;
        img {
          width: 173px;
        height: 221px;
        }
      }
      .right {
        padding:10px 30px;
        .name {
          font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          padding-bottom:25px;
        }
        .instruction {
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 300;
          color: #999999;
        }
      }
    }
    
  }
  .page-box {
      text-align: center;
      padding-bottom: 33px;
      margin-right: 75px;
     
      /deep/ .el-pagination .el-pager .active {
          background-color: #CC4C4D;
      }
      /deep/ .el-pagination.is-background .el-pager li:hover {
                color: #CC4C4D;
            }
    }
}
</style>
